import {IDatabase} from '../../../models';
import {getIconFor} from '../../../utils/custom-icons';
import {ExportType} from '../components';

const customIconProps = {
  width: 16,
  height: 16,
}

export const connectionToSelectOption = (value: IDatabase) => ({
  label: (value as IDatabase).database_name,
  value: value.uid as string,
  icon: getIconFor(value.backend as string, customIconProps),
});

export const getEditorOptions = (readOnly: boolean = false) => {
  return {
    enableBasicAutocompletion: true,
    enableLiveAutocompletion: false,
    highlightActiveLine: false,
    highlightGutterLine: false,
    showPrintMargin: false, // vertical line at N chars
    minLines: 10,
    readOnly
  };
};

export const getEditorProps = () => {
  return {
    contentEditable: false,
    $blockScrolling: true,
  }
}

export const getNowTS = () => {
  return new Date().getTime();
};

export const createDefaultContent = (
  databaseId: string | null = null,
  exportOptionType: ExportType | null = null,
) => {
  return {
    database_id: databaseId,
    limit: '1000',
    sql: '',
    export_options: {
      type: exportOptionType || ExportType.CSV,
    },
  }
};

export const getRowsDuration = (query: any) => {
  if (!query) {
    return '';
  }
  const rows = query.rows;

  return `${rows} ${rows === 1 ? 'row' : 'rows'} in ${getDuration(query)}s`;
}

export const getDuration = (query: any) => {
  if (!query.endDttm) {
    return '-';
  }
  return Math.floor(((query?.endDttm - query?.startDttm) / 1000) * 100) / 100;
}
